import * as React from "react";
import { useState } from "react";
import { Button } from "components/bootstrap";
import { ConfirmDialog, IfPermitted } from "components/common";
import { useDeleteDataLakeBackend } from "data-lake/data-lake-backend-config/hooks/useDataLakeBackendMutation";
const DeleteDataLakeAction = ({ backend }) => {
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const { mutateAsync: deleteBackend } = useDeleteDataLakeBackend();
  const onDeleteSubmit = () => {
    deleteBackend(backend.id).catch(() => void 0).finally(() => {
      setShowConfirmDelete(false);
    });
  };
  const onDelete = () => {
    setShowConfirmDelete(true);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "data_lake_backend_config:delete" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", onClick: onDelete }, "Delete")), showConfirmDelete && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      title: `Deleting ${backend.title} Data Lake backend, are you sure?`,
      show: true,
      onConfirm: onDeleteSubmit,
      onCancel: () => setShowConfirmDelete(false)
    },
    /* @__PURE__ */ React.createElement("p", null, `You are about to remove ${backend.title} Data Lake backend. This action cannot be undone.`)
  ));
};
export default DeleteDataLakeAction;
